import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, HStack } from '@chakra-ui/react';
/**
 * A small cream chip stating context: the period of the figures, the page
 * read with the question.
 */
export function InfoChip({ icon, children, ...props }) {
    return (_jsxs(HStack, { as: "span", display: "inline-flex", alignSelf: "flex-start", gap: "1.5", h: "6", maxW: "full", ps: "2", pe: "2.5", borderRadius: "sm", bg: "agent.subtle", textStyle: "agent.label", color: "agent.fgBody", whiteSpace: "nowrap", ...props, children: [_jsx(Box, { as: "span", color: "agent.fgMuted", display: "inline-flex", flexShrink: 0, "aria-hidden": "true", children: icon }), children] }));
}
